module.exports = __webpack_public_path__ + "static/media/social_shared_image.6f449543.jpg";